import React from 'react';

export default function SubHeading({
  timeRange,
  numberOfSites = '',
  totalNumberOfPallets = '',
}) {
  return (
    <React.Fragment>
      <div>
        <b>Customer data:</b>
        {timeRange &&
          timeRange.from &&
          timeRange.to &&
          ` ${timeRange.from.format('YYYY-MM-DD')} to ${timeRange.to.format(
            'YYYY-MM-DD',
          )}`}
      </div>
      <div>
        <b>Number of sites:</b> {numberOfSites}
      </div>
      <div>
        <b>Total pallets:</b> {totalNumberOfPallets.toLocaleString()}
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/Dashboard/SubHeading.js